export default __webpack_public_path__ + "edb54b9fdcdf3540d69f081dadb056e7.svg";